import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesToolPanel extends Layout {
    buttonReadyToSubmit: Button;
    buttonReverseTransfer: Button;
    buttonUpdateStatuses: Button;
    panelButtons: Panel;
    panelOne: Panel;
    panelTwo: Panel;
}
